
import { Link, useLocation } from "react-router-dom";





const AdMaxHeader = () => {

    const {pathname} = useLocation(); 

    
    return <div className="d-flex">
                <div className="section_sub_heading">
                    <Link className={pathname === "/admin/dashboard/admax/ads" ? "active w-90" : "w-90"} to="/admin/dashboard/admax/ads"><span><span className="firstHeading">Classic</span> <br/>(Banners)</span></Link>
                </div>
                <div className="section_sub_heading">
                    <Link className={pathname === "/admin/dashboard/admax/audio-ads" ? "active w-90" : "w-90"} to="/admin/dashboard/admax/audio-ads"><span><span className="firstHeading">Audio</span> <br/>(Pre-roll)</span></Link>
                </div>
                <div className="section_sub_heading">
                    <Link className={pathname === "/admin/dashboard/admax/video-ads" ? "active w-90" : "w-90"} to="/admin/dashboard/admax/video-ads"><span><span className="firstHeading">Video</span> <br/>(Pre-roll)</span></Link>
                </div>
            </div>;

}

export default AdMaxHeader;